import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withModifiers as _withModifiers, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-11dfc9fa"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "app-file-select-element" }
const _hoisted_2 = ["onClick"]
const _hoisted_3 = { class: "file-title" }
const _hoisted_4 = ["onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_File = _resolveComponent("File")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.editors, ([k, e]) => {
      return (_openBlock(), _createElementBlock("div", {
        key: k,
        class: _normalizeClass(['file', { active: k === this.active }]),
        onClick: ($event: any) => (_ctx.$emit('switch', k))
      }, [
        _createVNode(_component_File, { class: "file-icon" }),
        _createElementVNode("p", _hoisted_3, _toDisplayString(e.name), 1),
        _createElementVNode("p", {
          class: "file-close",
          onClick: _withModifiers(($event: any) => (_ctx.$emit('close', k)), ["stop"])
        }, "✗", 8, _hoisted_4)
      ], 10, _hoisted_2))
    }), 128))
  ]))
}